import { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import styles from "./AttendanceReport.module.css"

// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'
// ------ Components ------ //
import EventAttendees from "../../../components/Badging/AttendanceReport/EventAttendees"
import EventAdHocAttendees from "../../../components/Badging/AttendanceReport/EventAdHocAttendees"
const AttendanceReport = () => {
    const location = useLocation()
    const navigate = useNavigate()
    // ------ State Variables ------ //
    const [eventAttendees, setEventAttendees] = useState({})
    const [eventAdHocAttendees, setEventAdHocAttendees] = useState({})
    const [eventAttendeesKey, setEventAttendeesKey] = useState(1)
    const [eventAdHocAttendeesKey, setEventAdHocAttendeesKey] = useState(2)
    const passedState = location.state
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])
    useEffect(() => {
        if (clientEventInfo && clientEventInfo.clientId !== undefined && clientEventInfo.clientName) {
            // have to trigger component refresh
            let tempAttendees = eventAttendeesKey;
            setEventAttendeesKey(tempAttendees + 1)
            let tempAdHocAttendees = eventAdHocAttendeesKey;
            setEventAdHocAttendeesKey(tempAdHocAttendees + 1)
        }

    }, [clientEventInfo])
    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
    // export should be an button for all DS FIX Add charting as user action to each column header, navigate to new page
    return (
        <div className="page-area">
            <>
                <h1>Attendance Report</h1>
                <br />
                <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                <br /> <br />
                <Tabs>
                    <TabList>
                        <Tab>Event Attendees</Tab>
                        <Tab>Event AdHoc Attendees</Tab>
                    </TabList>
                    <TabPanel>
                        <>
                            {clientEventInfo && clientEventInfo.clientId ? 
                                <EventAttendees
                                    key={eventAttendeesKey }
                                    clientEventInfo={clientEventInfo}
                                    setEventAttendees={setEventAttendees}
                                    eventAttendees={eventAttendees}
                                ></EventAttendees>
                                :<></>
                                }
                            
                        </>
                    </TabPanel>
                    <TabPanel>
                        <>
                            {clientEventInfo && clientEventInfo.clientId ?
                                <EventAdHocAttendees
                                    key={eventAdHocAttendeesKey}
                                    clientEventInfo={clientEventInfo}
                                    setEventAdHocAttendees={setEventAdHocAttendees}
                                    eventAdHocAttendees={eventAdHocAttendees}
                                ></EventAdHocAttendees>
                                : <></>
                            }

                        </>
                    </TabPanel>
                </Tabs>
                <br />

            </>
        </div>
    );
}

export default AttendanceReport;